import api from './api';
import formDataApi from './formDataApi';
import ajaxApiNoAuthorize from './ajaxApiNoAuthorize';
import pdfApi from './pdfApi';

export {
  api,
  formDataApi,
  ajaxApiNoAuthorize,
  pdfApi,
};


// WEBPACK FOOTER //
// ./src/api-services/index.js